module.exports = __webpack_public_path__ + "img/nz.d8f18b1d.png";